module.exports = __webpack_public_path__ + "static/media/news.615868e0.svg";